export default __webpack_public_path__ + "static/media/fund.e66a6c6a.png";